import loadReduxAction from 'modules/redux/actions/load'
import {
  WORKOUTS_ACTION,
  WORKOUTS_DOMAIN,
  WORKOUTS_ENDPOINT,
  WORKOUTS_PATH
} from 'modules/workout/redux/constants'
import getEndpointTrainingUtil from 'modules/training/utils/get-endpoint'
import getPathFromDomainPathReduxUtil from 'modules/redux/utils/get-path-from-domain-map-path'
import { WORKOUT_CLASS_NAME } from 'modules/training/models/workout/constants'
import interpolateRouteUtil from 'modules/routes/utils/interpolate'
import {
  getObjectUtil,
  logUtil
} from 'packages/src'
import getActionStrReduxUtil from 'modules/redux/utils/get-action-str/index.js'
import { getLocationQueryParamsRouterSelect } from 'modules/router/selectors/index.js'

function loadByRecommendedIdWorkoutAction (params = {}) {
  return async (dispatch, getState) => {
    const id = params.id || getObjectUtil(params, 'match.params.id')
    const logLabel = 'loadByRecommendedIdWorkoutAction'
    const logPrefix = `id=${id}`
    if (!id) {
      logUtil(logLabel).warn('id not provided')
      return
    }

    const queryParams = getLocationQueryParamsRouterSelect(getState())
    const debugProps = { queryParams }
    logUtil(logLabel).debug(`${logPrefix} debugProps=`, debugProps)

    try {
      await dispatch(
        loadReduxAction({
          type: getActionStrReduxUtil(
            WORKOUTS_ACTION.LOAD_RECOMMENDED_BY_ID,
            id
          ),
          payload: {
            endpoint: getEndpointTrainingUtil(
              interpolateRouteUtil(
                WORKOUTS_ENDPOINT.LOAD_RECOMMENDED_BY_ID, { id }
              )
            ),
            domainListPath: WORKOUTS_PATH.ALL,
            path: getPathFromDomainPathReduxUtil(WORKOUTS_DOMAIN, id),
            data: {
              id,
              className: WORKOUT_CLASS_NAME
            }
          },
          options: params.options
        })
      )
      logUtil(logLabel).debug(`${logPrefix} [done]`)
    } catch (error) {
      logUtil(logLabel).error(`${logPrefix} error=`, error)
    }
  }
}

export default loadByRecommendedIdWorkoutAction
